import ReadMore from "@/components/read-more";
import ErrorBoundary from "../utils/error-boundary";

const ReadMoreApp = (props) => (
  <ErrorBoundary>
    <ReadMore {...props}>{props.text}</ReadMore>
  </ErrorBoundary>
);

export default ReadMoreApp;
